export default __webpack_public_path__ + "static/media/check.2b2a481f.svg";